import { useGLTF } from '@react-three/drei';
import type { ThreeElements } from '@react-three/fiber';

const GOAL_URL = '/goal.glb';

type GoalProps = ThreeElements['group'] & {
  facing?: 'north' | 'south';
};

/**
 * Suspended-net soccer goal model. `facing='north'` opens toward +z (own end);
 * 'south' opens toward -z (attacking end).
 */
export function Goal({ facing = 'north', ...rest }: GoalProps) {
  const { scene } = useGLTF(GOAL_URL);
  // Clone so the same GLB can be mounted twice in the scene.
  const clone = scene.clone(true);
  return (
    <group {...rest} rotation={facing === 'south' ? [0, Math.PI, 0] : [0, 0, 0]}>
      <primitive object={clone} />
    </group>
  );
}

useGLTF.preload(GOAL_URL);
